const CONSTANTS = {
  //  API_URL: 'https://test.kotharihyundai.com',
  // API_URL: 'http://localhost:9000',
  // API_URL: 'http://192.168.1.62:9000',
  // API_URL: 'http://192.168.1.54:9000',
  // API_URL: 'http://192.168.1.7:9000',
  API_URL: 'https://app.kotharihyundai.com',
  SOCKETAPI_URL: 'https://sockettest.kotharihyundai.com/api/',
  // API_URL: process.env.API_URL || 'http://localhost:9000',
  publicVapidKey: 'BHar8mMOW2JOSM37IQcHphtHytCHeIY86qvUaoFJdvypSllGSFuc4QSvXxnWtgyVYQBOOZsQPcW64W7V07mRCLc',
  googleMapsAPIKey: 'AIzaSyD-RwRvBoJNoG_vPeVwkJ4fl6mL85lUzr8',
  defaultCenter: {
    lat: 20.7493472,
    lng: 78.5759262
  },
  center: {
    lat: 20.7493472,
    lng: 78.5759262
  },
  defaultZoom: 10
};

// function getCurrentLocation(position) {//eslint-disable-line
//   CONSTANTS.defaultCenter = {
//     // lat: Number(position.coords.latitude.toFixed(7)),
//     // lng: Number(position.coords.longitude.toFixed(7))
//     lat: 20.7493472,
//     lng: 78.5759262
//   };
// }

// (function getGeoLocation() {
//   if (navigator.geolocation) {
//     navigator.geolocation.getCurrentPosition(getCurrentLocation);
//   } else {
//     alert('Geolocation is not supported by this browser.');
//   }
// })();

export default CONSTANTS;
